import React from "react";
import { Badge } from "components/lib";
import TableActions from "./actions";
import { CellWithTooltip } from "./CellWithTooltip";
import Style from "./table.tailwind.js";

export function Body(props) {
  if (props.data?.length) {
    return (
      <tbody className={Style.body}>
        {props.data.map((row, index) => {
          return <Row {...props} data={row} key={index} />;
        })}
      </tbody>
    );
  }

  return (
    <tbody className={Style.body}>
      <tr>
        <td colSpan="10" className={Style.empty}>
          No se encontraron resultados
        </td>
      </tr>
    </tbody>
  );
}

export function Row(props) {
  let row = { ...props.data };
  row.actions = row.actions || props.actions;
  const hasActions = Object.values(row.actions).some((x) => x !== undefined);

  // Usar las columnas pasadas por props o arrays vacíos por defecto
  const truncateColumns = props.truncateColumns || [];
  const mobileHiddenColumns = props.mobileHiddenColumns || [];
  const tabletHiddenColumns = props.tabletHiddenColumns || [];

  return (
    <tr data-id={props.data.id}>
      {Object.keys(row).map((cell, index) => {
        // actions
        if (cell === "actions")
          return hasActions ? (
            <TableActions
              row={row}
              index={index}
              key={index}
              callback={props.callback}
            />
          ) : (
            false
          );

        // hide
        if (props.hide?.includes(cell)) return false;

        // show
        if (props.show && !props.show.includes(cell)) return false;

        let value = row[cell];

        // is date/time
        if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(value)) {
          const date = new Date(value).toISOString().split("T");
          value = `${date[0]} ${date[1].split(".")[0]}`;
        }

        // Determinar clases CSS responsivas dinámicamente
        let responsiveClasses = '';
        if (mobileHiddenColumns.includes(cell)) {
          responsiveClasses += ` ${Style.hiddenMobile}`;
        } else if (tabletHiddenColumns.includes(cell)) {
          responsiveClasses += ` ${Style.hiddenTablet}`;
        }

        // has badge
        if (
          value !== undefined &&
          props.badge &&
          cell === props.badge.col
        ) {
          // default color
          let color = props.badge.color;
          let valueView = value;

          // check each condition
          if (props.badge.condition) {
            props.badge.condition.forEach((cond) => {
              typeof cond.value === "string" && typeof value === "string"
                ? (color =
                    cond.value.toLowerCase() === value.toLowerCase()
                      ? cond.color
                      : color)
                : (color = cond.value === value ? cond.color : color);

              if (cond.label) {
                valueView =
                  cond.value.toLowerCase() === value.toLowerCase()
                    ? cond.label
                    : valueView;
              }
            });
          }

          return (
            <td key={index} className={`${Style.cell}${responsiveClasses}`}>
              <Badge
                text={
                  valueView === true
                    ? "Sí"
                    : valueView === false
                    ? "No"
                    : valueView
                }
                color={color}
                className={Style.badge}
              />
            </td>
          );
        }

        // standard cell with optional truncation
        const displayValue = value === true ? "Sí" : value === false ? "No" : value;
        const shouldTruncate = truncateColumns.includes(cell);

        return (
          <td key={index} className={`${Style.cell}${responsiveClasses}`}>
            {shouldTruncate ? (
              <CellWithTooltip maxLength={props.truncateLength || 50}>
                {displayValue}
              </CellWithTooltip>
            ) : (
              displayValue
            )}
          </td>
        );
      })}
    </tr>
  );
}
